import { render } from "./ProductSelectionProductsSelectionItemPreview.vue?vue&type=template&id=381acace&scoped=true&ts=true"
import script from "./ProductSelectionProductsSelectionItemPreview.vue?vue&type=script&lang=ts"
export * from "./ProductSelectionProductsSelectionItemPreview.vue?vue&type=script&lang=ts"

import "./ProductSelectionProductsSelectionItemPreview.vue?vue&type=style&index=0&id=381acace&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381acace"]])

export default __exports__